import { Td, Tr } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { FaChevronCircleRight, FaChevronCircleUp } from 'react-icons/fa';

import { TableColumn, TableGroupRowData } from '../types';
import { TableRow } from './table-row';

export function TableGroupRow<I extends EntityBase = EntityBase>({ 
  columns, keyProperty, groupData, loading, selectedRow, onRowClick, getRowBackgroundColor,
}: {
  columns: TableColumn<I>[],
  rowIndex: number,
  groupData: TableGroupRowData<I>,
  keyProperty: keyof I,
  loading?: boolean
  selectedRow?: I | TableGroupRowData<I>,
  onRowClick?: (row: I | TableGroupRowData<I>) => void
  getRowBackgroundColor?: (rowData: I, rowIndex: number) => string | undefined;
}) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const groupRow = useMemo(() => {
    return <Tr 
      _hover={{ backgroundColor: onRowClick ? 'gray.200' : 'gray.50' }} 
      cursor={onRowClick ? 'pointer' : 'default'}
      backgroundColor={(selectedRow as TableGroupRowData<I>)?.group === groupData.group ? 'light.400 !important' : 'white'}
      onClick={() => onRowClick?.(groupData)}
    >
      <Td 
        px={3}
      > 
        <FaChevronCircleRight 
          style={{
            transform: isCollapsed ? 'rotate(0deg)' : 'rotate(90deg)',
            transition: 'all 0.5s ease',
            cursor: 'pointer',
            color: 'var(--chakra-colors-brand-500)',
          }}
          size={18}
          onClick={(e) => {
            e.stopPropagation();
            setIsCollapsed(!isCollapsed);
          }}
        />
      </Td>
      {columns.map((column, columnIndex) => {
        return <Td 
          key={`${column.name.toString()}_${columnIndex}`}
          borderColor='gray.300'
        >
          {groupData.column.options.group.rowRender(groupData.group, column, groupData.items)}
        </Td>;
      })}
    </Tr>;
  }, [groupData, isCollapsed]);

  return <>
    {groupRow}
    {(groupData.items.length < 100 || !isCollapsed) && groupData.items.map((item, itemIndex) => <TableRow
      key={`${item[keyProperty]}_${itemIndex}`}
      columns={columns} 
      rowIndex={itemIndex} 
      rowData={item}  
      loading={loading}    
      grouped
      hasGroups
      collapsed={isCollapsed} 
      selectedRow={selectedRow}
      onRowClick={onRowClick}
      totalRows={groupData.items.length}
      getRowBackgroundColor={getRowBackgroundColor}
    />)}
  </>;
}